import React from 'react';
import useData from '../hooks/useData';

const Loading = () => {
	const { dataFetched } = useData();

	return (
		<div id='Loading' className={dataFetched ? '' : 'active'}>
			<div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
		</div>
	)
}

export default Loading;